export const state = {
	site: null
}



// WEBPACK FOOTER //
// ./src/common/store/Site/state.js